module.exports = __webpack_public_path__ + "img/engineering.52cc4baf.png";